import { useQuery } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { ICalculateDonationFeeResponse } from '../../surveys/models/Api';

type IProps = {
	surveyId: string;
	value: number;
};

export const USE_CLIENT_CALCULATE_DONATION_FEE = 'useClientCalculateDonationFee';

export const useClientCalculateDonationFee = ({ surveyId, value }: IProps) => {
	const { apiClient } = useApiClientContext();

	return useQuery({
		enabled: Boolean(surveyId) && Boolean(value),
		queryKey: [USE_CLIENT_CALCULATE_DONATION_FEE, surveyId, value],
		queryFn: () => {
			return apiClient.post<ICalculateDonationFeeResponse>(`survey/donation/${surveyId}/calculateFees`, value);
		},
	});
};
